<template>
  <div class="personal" id="personal">
    <!-- 个人中心 -->
    <!-- <el-row :gutter="0">
      <el-col :span="6">
        <div class="top_aside"></div>
        <el-aside>
          <SideBar />
        </el-aside>
      </el-col>
      <el-col :span="18">
        <div class="top_right">
          视频门户主页
          <span>
            <router-link to="/home">首页</router-link>
          </span>
        </div>
        <div class="personal_right">
          <router-view></router-view>
        </div>
      </el-col>
    </el-row>-->
    <el-container style="height:100%;">
      <el-header>
        <Top/>
      </el-header>

      <el-container style="height:100%;">
        <el-aside width="220px" style="height:auto;">
          <SideBar />
        </el-aside>

        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import SideBar from "@/components/layout/sidebar2.vue";
import Top from '@/components/top/top.vue';
export default {
  components: {
    SideBar,
    Top
  }
};
</script>

<style scoped lang="scss">
.personal {
  overflow-y: hidden;
  width: 100%;
  height: 100%;
  // padding: 0 20px;
  margin: 0px auto;
  .el-aside {
    text-align: left;
    // min-height: 300px;
    // background-color: #303133;
    height: 100%;
  }
  .el-header {
    // background-color: #409eff;
    background-color: #5cb6e4;
    line-height: 60px;
    padding-left: 0px;
  }
  .el-container {
    height: 100%;
  }
  .el-main {
    // margin: 20px;
    // box-shadow: 0 0 3px #ccc;
    // border-radius: 3px;
    background-color: #E9EEF3;
    height: 100%;
  }
}
// .personal_right {
//   text-align: left;
//   padding: 20px 10px;
//   //   border:1px solid red;
//   min-height: 600px;
//   background-color: #fff;
// }
// .top_aside {
//   height: 80px;
//   width: 300px;
//   background-color: #fff;
//   border-bottom: 1px solid #ccc;
//   border-right: 1px solid #ccc;
// }
// .top_right {
//   height: 80px;
//   line-height: 80px;
//   background-color: #fff;
//   border-bottom: 1px solid #ccc;
//   text-align: left;
//   padding: 0 20px;
// }
</style>



// WEBPACK FOOTER //
// src/components/personalcenter/administrator/administrator.vue